import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';
import { CopySink } from 'app/model/pipeline/copysink/copysink';

export class GenericCopySinkAdapter extends CopySinkAdapter<CopySink, Model.CopySink> {
    protected override async _toResource(copySink: CopySink): Promise<Model.CopySink> {
        return CopySinkAdapter.getCommonCopySinkProperties(copySink, Metamodel.modelOf(copySink).name);
    }

    protected override async _toModel(copySink: Model.CopySink): Promise<CopySink> {
        const model = Metamodel.modelByName(copySink.type);
        return model.create<CopySink>();
    }
}
